import { Outlet } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { RequisitionsTable } from './RequisitionsTable'

const JobsRequisitionsPage = () => {
  return (
    <ResponsivePage.Body variant="full" showHeader={false}>
      <RequisitionsTable />
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default JobsRequisitionsPage
